import { CzechSuklRsAtcGroupResponse } from 'com.cogvio.pricemonitor.api';

import { sortGroupProducts } from './sortGroupProducts';

export type GroupProductEntry = {
	product: CzechSuklRsAtcGroupResponse['products'][number];
	productIndex: number;
	versions: CzechSuklRsAtcGroupResponse['products'][number]['productVersions'];
};

/**
 * Iterates products within an ATC/RS group with their version lists.
 * Products are sorted by brand name, then pack description.
 *
 * @param {CzechSuklRsAtcGroupResponse} group the group to iterate.
 * @returns {GroupProductEntry[]} products with their version lists.
 */
export function iterateGroupProducts(group: CzechSuklRsAtcGroupResponse): GroupProductEntry[] {
	const products = group.products.map((product, productIndex) => ({
		product,
		productIndex,
		versions: product.productVersions,
	}));

	return sortGroupProducts(products);
}
